/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CheckAvailabilityDto { 
    /**
     * Start date in ISO 8601 format
     */
    start: string;
    /**
     * Positive value representing the amount of time
     */
    value: number;
    /**
     * Unit of time
     */
    unit: CheckAvailabilityDto.UnitEnum;
}
export namespace CheckAvailabilityDto {
    export const UnitEnum = {
        Seconds: 'seconds',
        Minutes: 'minutes',
        Hours: 'hours',
        Days: 'days',
        Weeks: 'weeks',
        Months: 'months',
        Years: 'years'
    } as const;
    export type UnitEnum = typeof UnitEnum[keyof typeof UnitEnum];
}


